module.exports = __webpack_public_path__ + "static/media/multi_opti_zoom.c80db4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/multi_opti_zoom.png
// module id = 110
// module chunks = 0